export default function combineDateTime(date, time) {
  const dateObj = new Date(date);
  const timeObj = new Date(time);
  dateObj.setHours(timeObj.getHours());
  dateObj.setMinutes(timeObj.getMinutes());
  return dateObj;
}